import {
  setFileToAttachSelected,
  setFileToAttachToReport,
} from "app/store/transmission/slice/transmissionSlice";
import ConfirmModal from "components/common/modals/confirmModal/ConfirmModal";
import ModalWrapper from "components/common/modals/modalWrapper/ModalWrapper";
import React from "react";
import { useSelector } from "react-redux";
import useInsertPage from "../../hooks/useInsertPage";
import InsertPage from "./InsertPage";

const InsertPageModal = (props) => {
  const {
    newPagePosition,
    showConfirmModal,
    isReportNoteEditable,
    originalPDFTotalPages,
    newPageAfterPageNumber,
    isConfirmingReportUpdate,

    onClose,
    onCancel,
    dispatch,
    handleFileUpload,
    setNewPagePosition,
    setShowConfirmModal,
    handleUpdateNewReport,
    setNewPageAfterPageNumber,
  } = useInsertPage(props);
  const { fileToAttachToReport, originalFileToAttachToReport } = useSelector(
    (state) => state.transmission
  );

  return (
    <>
      <ModalWrapper
        show={true}
        showTitle={true}
        maxWidth="md"
        maxHeight={fileToAttachToReport?.pdfUrl ? "md" : "sm"}
        showCloseIcon={true}
        headerStyle={{ padding: "4px 24px" }}
        onClose={onClose}
        title="Insert pages to report"
        children={
          <InsertPage
            newPagePosition={newPagePosition}
            isReportNoteEditMode={isReportNoteEditable}
            originalPDFTotalPages={originalPDFTotalPages}
            newPageAfterPageNumber={newPageAfterPageNumber}
            onCancel={onCancel}
            handleFileUpload={handleFileUpload}
            setNewPagePosition={setNewPagePosition}
            setNewPageAfterPageNumber={setNewPageAfterPageNumber}
          />
        }
        actionButtons={
          fileToAttachToReport?.pdfUrl
            ? [
                {
                  label: "Cancel",
                  variant: "outlined",
                  onClick: () => {
                    onClose();
                    dispatch(
                      setFileToAttachToReport(originalFileToAttachToReport)
                    );
                  },
                },
                {
                  label: "Update",
                  variant: "contained",
                  color: "secondary",
                  tooltip: "Save the report before inserting page",
                  disabled: isReportNoteEditable,
                  onClick: () => setShowConfirmModal(true),
                },
              ]
            : []
        }
      />

      {showConfirmModal && (
        <ConfirmModal
          confirmText="Confirm"
          show={showConfirmModal}
          onConfirm={handleUpdateNewReport}
          title="Add pages to transmission report"
          isConfirming={isConfirmingReportUpdate}
          onCancel={() => {
            dispatch(setFileToAttachToReport(originalFileToAttachToReport));
            dispatch(setFileToAttachSelected(false));
            setShowConfirmModal(false);
          }}
          children={
            <span>
              Are you sure you want to attach these pages to the report? <br />
              Once confirmed, this cannot be undone.
            </span>
          }
        />
      )}
    </>
  );
};

export default InsertPageModal;
